import axios from 'axios';
import { catchError } from './common';
import { authenticatedFetch } from '@/utils/authenticatedFetch';

export const getDivisionsWithBrand = async () => {
  try {
    const response = await axios.get(
      `${import.meta.env.VITE_API_DOMAIN}${import.meta.env.VITE_API_VERSION}/ai/agents/brand-agent/division-brands`
    );
    return response?.data;
  } catch (error) {
    console.error(error);
    catchError(error);
  }
};

export const getBrandDetails = async (brandId: string) => {
  try {
    const response = await axios.get(
      `${import.meta.env.VITE_API_DOMAIN}${import.meta.env.VITE_API_VERSION}/ai/agents/brand-agent/brand/${brandId}`
    );
    return response?.data;
  } catch (error: any) {
    if (error.response.status === 404) {
      return { agentAlreadyExists: false };
    }
    console.error(error);
    // catchError(error);
  }
};

export const postBrandConfiguration = async (payload: any) => {
  try {
    const response = await axios.post(
      `${import.meta.env.VITE_API_DOMAIN}${import.meta.env.VITE_API_VERSION}/ai/agents/brand-agent/`,
      payload
    );

    return response;
  } catch (error) {
    console.error(error);
    catchError(error);
  }
};

export const putBrandConfiguration = async (payload: any, brandId: string) => {
  try {
    const response = await axios.put(
      `${import.meta.env.VITE_API_DOMAIN}${import.meta.env.VITE_API_VERSION}/ai/agents/brand-agent/${brandId}`,
      payload
    );

    return response;
  } catch (error) {
    console.error(error);
    catchError(error);
  }
};

export const getTovFromFile = async (formData) => {
  try {
    const response = await authenticatedFetch(
      `${import.meta.env.VITE_API_DOMAIN}${import.meta.env.VITE_API_VERSION}/ai/agents/brand-agent/tone-of-voice/extractions`,
      {
        method: 'POST',
        body: formData,
      }
    );
    if (!response?.ok) {
      const res = await response.json();
      throw new Error(res?.detail || 'something went wrong');
    }
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
